<template>
    <div class="position-relative" @mouseleave="checkClosePop()">
        <div v-if="visible && tools" class="position-relative">
            <ButtonPopup
                v-if="folder.access === 'manage' && !isLoading"
                container-class="position-absolute e3-folder-edit"
                button-class="btn text-white bg-primary rounded-circle p-1"
                :title="$t('Manage')"
                :popper-options="popperOptions"
                @open="keepActive = true"
                @close="hidePop()">
                <CogIcon size="18" class="text-white"/>
                <template #popup="{ close }">
                    <div class="d-flex">
                        <RoundIconButton
                            class="mr-2"
                            :title="$t('Edit')"
                            @click="openModal(close)"/>
                        <RoundIconButton
                            type="btn-danger"
                            :title="$t('Delete')"
                            @click="openDelModal(close)">
                            <TrashCanIcon size="18" class="text-white"/>
                        </RoundIconButton>
                    </div>
                </template>
            </ButtonPopup>
        </div>
        <div class="e3-folder-container d-flex flex-lg-column align-items-center" :title="folder.name" @mouseover="showVisible()">
            <router-link 
                v-click-outside="unHighlight"
                :to="{name: folder.type+'.folder', params: {'folder': folder.id}}"
                class="e3-folder-box d-flex align-items-center pb-1"
                :class="{'grid flex-column' : isGrid, 'flex-lg-column' : !isGrid, 'e3-new-index-folder': isFolderNew(folder.updated_at) && newCreated}">
                <FolderIcon :is-gallery="isGallery" :is-readonly="isReadonly" :is-grid="isGrid"/>
                <div
                    class="d-flex align-items-center text-center text-dark text-break px-3 h-100 folder-name overflow-hidden pt-1"
                    :class="isGrid ? 'px-1' : 'px-lg-1'">
                    <span v-if="!searchValue" class="folder-name-clamp">
                        {{ folder.name }}
                    </span>
                    <span v-else :inner-html.prop="searchHighlight(folder.name, searchValue)" class="folder-name-clamp"/>
                </div>
            </router-link>
        </div>
        <b-modal :id="`delete-folder-${id}-${type}`" lazy static hide-footer>
            <template #modal-header>
                <ModalHeader :modal-name="`delete-folder-${id}-${type}`">{{ $t('Delete '+ entity) }}</ModalHeader>
            </template>
            <div class="text-center font-weight-bold">
                <p>{{ $t('Are you sure you want to delete the ' + entity, {name: folder.name}) }}</p>
            </div>
            <div class="row justify-content-end pt-3 pr-3 mt-4">
                <button class="btn btn-secondary mr-2" @click="closeDelModal">
                    {{ $t('Cancel') }}
                </button>
                <button class="btn btn-danger" @click="deleteFolder">
                    {{ $t('Delete') }}
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { eventBus } from '@/main';
import {searchHighlight} from '@/filters';
import ButtonPopup from '@components/button-popup/ButtonPopup.vue';
import FolderIcon from '@views/folder/components/FolderIcon.vue';
import CogIcon from '@components/svg-icons/CogIcon.vue';
import TrashCanIcon from '@components/svg-icons/TrashCanIcon.vue';

export default {
    name: 'FolderContainer',
    props: {
        folder: {
            type: Object,
            default: () => ({
                // TYPES
                /*
                id: number;
                name: string;
                type: string;
                access: string;
                updated_at: string;
                */
            })
        },
        id: String,
        tools: {
            type: Boolean,
            default: false
        },
        type: String,
        searchValue: String,
        isGrid: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            visible: false,
            keepActive: false,
            newCreated: false,
            isLoading: false
        };
    },
    computed: {
        isGallery() {
            return this.folder.type === 'gallery';
        },
        isReadonly() {
            return this.folder.access === 'view';
        },
        entity() {
            return this.isGallery ? 'album' : 'folder';
        },
        popperOptions() {
            return {
                placement: 'top-start'
            };
        }
    },
    methods: {
        searchHighlight, // TODO: Vue3 remove
        deleteFolder() {
            this.isLoading = true;
            this.$store.dispatch('DELETE_FOLDER', this.folder.id).then(() => {
                this.$toastr.s(this.type === 'document' ? this.$t('Folder deleted') : this.$t('Album deleted'));
            }).finally(() => {
                this.isLoading = false;
            });
        },
        showVisible() {
            if (this.folder.access === 'manage') {
                this.visible = true;
            }
        },
        checkClosePop() {
            if (!this.keepActive) {
                this.visible = false;
            }
        },
        hidePop() {
            this.keepActive = false;
            this.visible = false;
        },
        openModal(close) {
            eventBus.$emit('show-index-edit-folder-modal', this.folder);
            close?.();
        },
        openDelModal(close) {
            this.$bvModal.show(`delete-folder-${this.id}-${this.type}`);
            close?.();
        },
        closeDelModal() {
            this.$bvModal.hide(`delete-folder-${this.id}-${this.type}`);
        },
        isFolderNew(updated_at) {
            const createdNow = this.$moment().diff(this.$moment(updated_at), 'seconds') === 0;
            if (createdNow) {
                this.newCreated = true;
            }
            return createdNow;
        },
        unHighlight() {
            if (this.newCreated) {
                this.newCreated = false;
            }
        }
    },
    components: {
        ButtonPopup,
        FolderIcon,
        CogIcon,
        TrashCanIcon
    }
};
</script>

<style scoped lang="scss">
@import "@common/styles/variables/_variables.scss";

    .e3-folder-box:hover{
        text-decoration: none;
    }
    .e3-folder-container:hover {
        .text-center.text-dark.text-break {
            text-decoration: underline;
            color: $primary !important;
        }
    }
    .folder-name {
        max-height: 52px;
    }

</style>
